import { render } from "./ReleaseRegistryComponent.vue?vue&type=template&id=77643482&scoped=true"
import script from "./ReleaseRegistryComponent.vue?vue&type=script&lang=js"
export * from "./ReleaseRegistryComponent.vue?vue&type=script&lang=js"

import "./ReleaseRegistryComponent.vue?vue&type=style&index=0&id=77643482&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77643482"]])

export default __exports__